import { createStore } from 'vuex'

export default createStore({
  state: {
    accessToken: '',
  },
  mutations: {
    setAccessToken(state, accessToken) {
      state.accessToken = accessToken
    },
  },
  actions: {},
  modules: {},
})
